<template>
    <TemplateBase>
        <template #default>
            <HomeHero
                :title="hero?.title ?? entry?.title"
                :description="hero?.subtitle"
                :image="hero?.image?.[0]"
            />
            <ContentBlocks v-if="entry?.contentBlocks" :content-blocks="entry.contentBlocks" />
            <NewsletterSignup v-if="entry?.newsletterSignupVisible" />
            <CtaCardsBlock v-if="entry?.ctaCardsVisible" />
        </template>
    </TemplateBase>
</template>

<script setup>
import HomeQuery from '~/graphql/queries/Entry.graphql';

const { variables: defaultVariables }  = useCraftGraphql();

const variables = computed(() => {
    return {
        ...defaultVariables,
        uri: undefined,
        section: 'home'
    };
});

const response = await useAsyncQuery({
    query: HomeQuery,
    variables
});

const { craftEntry: entry } = useSeoCraftPage(response);

const hero = computed(() => {
    return entry?.value?.homeHero?.[0] ?? null;
});

const generalStore = useGeneralStore();

generalStore.setPalette('palette--mma');
</script>
